<template>
  <div class="shop_wrapper">

    <!-- Modal -->
		<div v-if=" getFavlistsVisibility " class="modal fade" id="cartToFavlist" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog " role="document">
				<div class="modal-content ">
					<div class="modal-header bg-primary">
						<h5 class="modal-title text-white" id="exampleModalLabel">{{ $t('Guardar carrito en lista de favoritos') }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div :class=" { 'modal-body': true, 'block-loading': favlistModalLoading }">
						<div class="row">
							<div class="col-md-12">
								<label>{{ $t('Elige tu servicio') }}:</label>	
								<select v-model="servicesIdSelected">
									<option value="0" disabled>{{ $t('Elige tu servicio') }}</option>
									<option v-for=" item in getServices " :key="item.srv_id" :value="item.srv_id">{{ item.srv_name }}</option>
								</select>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 mt-4">
								<label>{{ $t('Crear nueva lista de favoritos') }}:</label>
								<form @submit.prevent="addFavlist" class="form-inline">
									<div class="input-group" style="width: 300px;">
										<input 
											v-model=" favlistNameNew " 
											:placeholder="$t('Nombre')"
											type="text"
										>
									</div>
									<button 
										type="submit" 
										:disabled=" !favlistNameNewValid "
										class="btn-biv c-bg-grey-blue"><i class="fa fa-plus-circle"></i>
									</button>
								</form>
							</div>
							<div class="col-md-12 mt-4">
								<label>{{ $t('Elige tu lista de favoritos') }}:</label>
								<select v-model="favlistIdSelected">
									<option value="0" disabled>{{ $t('Elige tu lista de favoritos') }}</option>
									<option v-for=" item in serviceSelectedFavlistsSorted " :key="item.fvl_id" :value="item.fvl_id">{{ item.fvl_name }} ({{ item.fvl_count > 0 ? item.fvl_count : 0 }})</option>
								</select>
							</div>
						</div>
					</div>
					<div class="modal-footer mt-4">
						<button 
							@click=" cartToFavlist() "
							:disabled=" favlistIdSelected == 0 "
							type="button" class="btn c-bg-grey-blue text-white mouse-hover">{{ $t('Guardar en lista de favoritos') }}</button>
						<button type="button" class="btn c-bg-blue-darker ml-1 mouse-hover" data-toggle="modal" data-target="#cartToFavlist">{{ $t('Cerrar') }}</button>
					</div>
				</div>
			</div>
		</div>

    <div class="modal fade" id="purchaseDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
				<div class="modal-content ">
					<div class="modal-header bg-primary">
						<h5 class="modal-title text-white" id="exampleModalLabel">{{ $t('Finalizar compra') }}</h5>
						<button 
              :disabled=" loading "
              type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

          <div :class=" { 'modal-body': true, 'block-loading': loading }">

            <template v-if=" purchase.state == 0 ">
              <template v-if="complements.data.length < 1">
                <div class=" text-center pt-5 mb-4">
                  <i class="fa fa-info-circle purchase-notice-icon"></i>
                </div>
                <h6 class="text-center pb-4">{{ $t('¿Estás seguro de finalizar la compra?') }}</h6>
              </template>
              <template v-else>
                <h6 class="pt-2 pb-4">{{ $t('También podrías necesitar') }}:</h6>
                <div class="row">
                  <div @click="purchase.dialog = false" v-for=" item, index in complements.data " :key="index" class="col-4" >
                    <div @click="goToComplement(item)" class="c-mouseHover">
                      <figure class="featured_category">
                        <div class="imagen" :style=" 'background: url('+getBaseUrl+getImgUrl+item.typ_image+');'"></div>
                        <span class="agua">{{ item.typ_name }}</span>
                      </figure>
                    </div>
                    <!-- <router-link :to="{ name: 'type', params: { language: getLocale, lin: setUrlParams(item.lin_id,item.lin_name), ctg: setUrlParams(item.ctg_id,item.ctg_name), sct: setUrlParams(item.sct_id,item.sct_name), typ: setUrlParams(item.typ_id,item.typ_name)  } }">
                      <figure class="featured_category">
                        <div class="imagen" :style=" 'background: url('+getBaseUrl+getImgUrl+item.typ_image+');'"></div>
                        <span class="agua">{{ item.typ_name }}</span>
                      </figure>
                    </router-link> -->
                  </div>
                </div>
              </template>              
            </template>

            <template v-if=" purchase.state == 1 ">
              <h6 class="text-center black mt-3">{{ $t('El pedido se ha realizado con éxito!') }}</h6>
              <div class="text-center my-3">
                <a
                  :href=" this.getApiUrl + '/pedido.php' "
                  target="_blank"
                  class="btn c-bg-grey-blue text-white mouseHover mr-2"
                >
                  {{ $t('Descargar PDF') }}
                </a>
              </div>

              <h6 class="mt-5 mb-2">{{ $t("Resumen del pedido:") }}</h6>

              <div class="table_desc mt-2 mb-2">
                <div class="cart_page table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th width="70">Ref</th>
                        <th width="70">Img</th>
                        <th>{{ $t('Producto') }}</th>
                        <th width="100" class="unitspp">{{ $t('Precio por unidad') }}</th> 
                        <th width="75" class="unitspp">{{ $t('Unidades') }}</th>                      
                        <th width="150">{{ $t('Total') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for=" (item, index) in items " :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.ref_number }}</td>
                        <td><img :src=" getBaseUrl + getImgUrl + item.ref_image " :alt=" $t('Imagen') + item.ref_description " class="product_thumb"></td>
                        <td class="product_name text-left">
                          <template v-if=" item.ref_number != 'PORTES1' ">                          
                            {{ item.ref_description }}
                          </template>
                          <template v-else>
                            {{ item.ref_description }}
                          </template>
                        </td>
                        <td class="text-right black">{{ (item.ref_price > 0) ? toCurrency(item.ref_price) : ( item.ref_number != 'PORTES1' ? $t('consultar') : ''  )  }}</td>       
                        <td class="text-right black">
                          <template v-if=" item.ref_quantity == 0 || item.editing ">
                            <input 
                              v-model.number=" item.updateValue " 
                              @keyup.enter=" updateItem(item) " 
                              v-focus="index === focused"
                              @focus="focused = index"
                              @blur="focused = null"
                              type="number" min="0" class="text-right"
                            >
                          </template>
                          <template v-else>
                            <span class="mr-input">{{ item.ref_quantity }}</span>
                          </template>
                        </td>
                        <td class="product_total text-right color-grey">{{ toCurrency(item.ref_quantity * item.ref_price) }}</td>
                      </tr>  
                      <tr v-if=" cartCount == 0 ">
                        <td colspan="11" class="text-center">{{ $t('El carrito está vacío') }}.</td>
                      </tr>          
                    </tbody>  
                    <tfoot>
                      <tr>
                        <td colspan="4"></td>
                        <td colspan="2" class="text-right black">{{ $t('Total Base') }}</td>
                        <td class="product_total text-right color-grey"><h5 class="mb-0">{{ toCurrency(totalBase) }}</h5></td>
                      </tr>  
                    </tfoot>                
                  </table>                  
                </div>         
              </div>
              <p class="text-center">{{ $t('Todos los precios indicados no incluyen IVA') }}.</p>
            </template>

            <template v-if=" purchase.state == 2 ">
             <div class=" text-center pt-5 mb-4">
                <i class="fa fa-close purchase-notice-icon red"></i>
              </div>
              <h6 class="text-center pb-3">{{ $t('Error en el formato XML') }}</h6>
              <p class="text-center px-5">{{ $t('Lo sentimos mucho, algo ha salido mal y no hemos podido procesar su') + ' ' + sessionType + '!' }}</p>
              <p class="text-center px-5 pt-1">{{ $t('Por favor, contacte con nosotros.') }}</p>

              <div class="text-center mt-3" v-html="purchase.xmlParseError"></div>
              
              <hr class="my-4">
              
              {{ purchase.xmlResponse }}

            </template> 

          </div>

					<div class="modal-footer mt-4">
            <button :disabled=" loading " type="button" class="btn c-bg-grey-blue text-white ml-1 mouse-hover" data-toggle="modal" data-target="#purchaseDialog">
              {{ purchase.state == 1 ? $t('Volver al carrito') : $t('Volver al carrito') }}
            </button>
						<button 
              v-if=" purchase.state == 0 "
							@click=" punchOut "
							:disabled=" loading "
							type="button" class="btn btn-green text-white mouse-hover"
            >
              {{ $t('Finalizar compra') }}
            </button>						
					</div>
				</div>
			</div>
    </div>

    <div class="shopping_cart_area">
      <div class="container">  
        <div class="row mb-4">
          <div class="col-3">
            <small class="form-text text-muted">
              {{ $t('Elige tu tipo de compra:') }}
            </small>
              <button @click="setCartType('cart')" type="button" :class="{ 'btn cart-type-btn': true, 'cart-type-active': isCart }">{{ $t('Carrito') }}</button><button @click="setCartType('offer')" type="button" :class="{ 'btn cart-type-btn': true, 'cart-type-active': !isCart }">{{ $t('Número de oferta') }}</button>
          </div>
          <div class="col-6">            
            <div class="contact_phone mt-2">
              <span class="question mt-2 mr-5">{{ $t('¿Tienes dudas con el pedido?') }}</span>                
              <div class="contact_icone">
                <span class="pe-7s-headphones"></span>
              </div> 
              <div class="contact_number">
                <p>{{ $t('Pedidos y logística') }}:</p>
				        <span><a href="tel:+34918294003">+34 918 294 003</a></span>
              </div>
            </div>
          </div>
          <div class="col-3 text-right mt-3">
            <button
              v-if=" getFavlistsVisibility && isCart "
              class="btn c-bg-grey-blue text-white mouseHover mt-2"
              v-tooltip:top.live=" $t('Guardar carrito en una lista de favoritos') "
              data-toggle="modal" data-target="#cartToFavlist"
              :disabled=" cartCount <= 0 "
            >
              <i class="pe-7s-cart cart"></i> <i class="fa fa-angle-right mr-2 ml-2"></i> <i class="fa fa-star-o"></i>
            </button>
          </div>
        </div>
        <div v-if="!isCart" class="mb-3" style="width: 340px">
          <small class="form-text text-muted">
            {{ $t('Introduce tú número de oferta (OFXXXXXXXX) y presiona intro:') }}
          </small>
          <div class="input-group">
            <input
              v-model="offer.value"
              @keyup.enter="offerLoad" 
              type="text"
              maxlength="10"
              :class="{ 'offer-input': true, 'input-invalid': offer.error }"
              placeholder="OF12345678"
            > 
            <button @click.prevent="offerLoad" class="btn-biv c-bg-grey-blue"><i class="ion-ios-search-strong px-1"></i></button>
            <div class="input-group-append offer-loading-width">
              <img v-show="offer.loading" :src=" getBaseUrl + '/assets-own/images/loading-rainbow-bg-w.svg' " class="offer-loading" width="20" height="20" alt="Spinning">
            </div>
          </div>
          <small class="form-text text-muted offer-message-height">
            <template v-if=" offerCharLack > 0">
              {{ $t('Faltan') }} {{ offerCharLack }} {{ $t('dígitos para completar el número de oferta') }}
            </template> 
            <span v-else-if=" offer.loading ">{{ $t('Buscando oferta...') }}</span>
            <span v-else :class=" offer.error ? 'offer-error' : 'offer-success' " v-html="offer.message"></span>
          </small>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table_desc">
              <div class="cart_page table-responsive">
                <table :class=" { 'loading': getShoppingCartLoading } ">
                  <thead>
                    <tr>
                      <th colspan="11" class="text-center" style="background: #EEE;">
                        {{ cartTitle }}
                      </th>
                    </tr>
                    <tr>
                      <th>#</th>
                      <th width="70">Ref</th>
                      <th width="70">Img</th>
                      <th>{{ $t('Producto') }}</th>
                      <th width="80" class="unitspp">{{ $t('Unidades por bolsa') }}</th>
                      <th width="60" class="unitspp">{{ $t('Completar bolsa') }}</th>
                      <th width="100" class="unitspp">{{ $t('Precio por unidad') }}</th> 
                      <th width="61" class="unitspp">{{ $t('Disponibilidad') }}</th>                    
                      <th width="75" class="unitspp">{{ $t('Unidades') }}</th>                      
                      <th width="115"></th>
                      <th width="150">{{ $t('Total') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for=" (item, index) in items " :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.ref_number }}</td>
                      <td><img :src=" getBaseUrl + getImgUrl + item.ref_image " :alt=" $t('Imagen') + item.ref_description " class="product_thumb"></td>
                      <td class="product_name text-left">
                        <template v-if=" item.ref_number != 'PORTES1' ">
                          <router-link
                            :to="{ name: 'type', params: { 
                              language: getLocale,
                              lin: setUrlParams(item.lin_id,item.lin_name),
                              ctg: setUrlParams(item.ctg_id,item.ctg_name),
                              sct: setUrlParams(item.sct_id,item.sct_name),
                              typ: setUrlParams(item.typ_id,item.typ_name)
                              } }" 
                            class="c-prod-link"
                            >
                            {{ item.ref_description }}
                          </router-link>
                        </template>
                        <template v-else>
                          {{ item.ref_description }}
                        </template>
                      </td>
                      <td class="color-light-grey">{{ isCart ? item.ref_unitspp : '' }}</td>
                      <td class="p-0 text-center">
                        <div 
                          v-if=" item.ref_quantity % item.ref_unitspp && isCart"
                          @click="onAlertSubmit( item )"
                          v-tooltip:top.live=" setAlertText( item.ref_quantity, item.ref_unitspp ) "
                          class="btn-fill-bolsa"
                        >
                          <i class="pe-7s-cart cart"></i>
                          <span class="count">+{{ item.ref_unitspp - (item.ref_quantity % item.ref_unitspp) }}</span>
                        </div>
                      </td>
                      <td class="text-right black">{{ (item.ref_price > 0) ? toCurrency(item.ref_price) : ( item.ref_number != 'PORTES1' ? $t('consultar') : ''  )  }}</td>       
                      <td class="stock">
                        <i v-if=" item.ref_stock == 'green' " class="fa fa-circle green"></i>
                        <i v-else-if=" item.ref_stock == 'yellow' " class="fa fa-circle yellow"></i>
                      </td>
                      <td class="text-right black">
                        <template v-if=" item.ref_quantity == 0 || item.editing && isCart">
                          <input 
                            v-model.number=" item.updateValue " 
                            @keyup.enter=" updateItem(item) " 
                            v-focus="index === focused"
                            @focus="focused = index"
                            @blur="focused = null"
                            type="number" min="0" class="text-right"
                          >
                        </template>
                        <template v-else>
                          <span class="mr-input">{{ item.ref_quantity }}</span>
                        </template>
                      </td>
                      <td class="text-right">
                        <template v-if=" item.ref_number != 'PORTES1' && isCart ">
                          <template v-if=" item.ref_quantity == 0 ">
                            <button @click.prevent=" addItem(item) " class="btn-biv add-to-card"><i class="fa fa-plus-circle"></i></button>
                          </template>
                          <template v-else>
                            <template v-if=" item.editing "> 
                              <button @click.prevent=" updateItem(item) " class="btn-biv update-cart"><i class="fa fa-floppy-o"></i></button>
                            </template>
                            <template v-else>
                              <button @click.prevent=" editItem(item, index) " class="btn-biv edit-cart"><i class="fa fa-pencil-square-o"></i></button>
                            </template>
                            <button  @click.prevent=" deleteItem(item) " class="btn-biv delete-from-cart"><i class="fa fa-trash"></i></button>
                          </template>	
                        </template>
                      </td>
                      <td class="product_total text-right color-grey">{{ toCurrency(item.ref_quantity * item.ref_price) }}</td>
                    </tr>  
                    <tr v-if=" cartCount == 0 && isCart ">
                      <td colspan="11" class="text-center">{{ $t('El carrito está vacío') }}.</td>
                    </tr>
                    <tr v-if="offerCount == 0 && !isCart ">
                      <td colspan="11" class="text-center">{{ $t('La oferta está vacía') }}.</td>
                    </tr>            
                  </tbody>                  
                </table>                  
              </div>         
            </div>

            <product-add v-if="isCart" />

          </div>
        </div>
        <div class="coupon_area">
          <div class="row">
            <div class="col-md-7 col-lg-7 col-md-7">
              <textarea
                v-if=" getSessionType != 'procure' " 
                v-model="observaciones" 
                cols="30" rows="3" class="mb-3" maxlength="500" :placeholder=" $t('Observaciones sobre el pedido')"
              ></textarea>

              <div class="coupon_code">
                <h3 class="bg-grey"><i class="fa fa-truck mr-2"></i>{{ $t('Gastos de envío') }}</h3>
                <div class="coupon_inner">
                  <div class="cart_subtotal mt-1">
                    <ul class="list">
                      <li>{{ $t('Portes pagados para pedidos superiores a 400 € que no incluyan tubería') }}</li>
                      <li>{{ $t('Portes pagados para pedidos superiores a 1500 € que incluyan tubería') }}</li>
                      <li>{{ $t('Resto de portes se cargan en pedido con IVA 21%') }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 offset-md-1 col-lg-4 offset-lg-1 col-md-4">
              <div :class=" { 'coupon_code right': true, 'block-loading': getShoppingCartLoading } ">
                <h3>{{ $t('Totales') }}</h3>
                <div class="coupon_inner">
                  <div class="cart_subtotal mt-3">
                    <p class="cart_amount">{{ $t('Total Base') }}</p>
                    <p class="cart_amount">{{ toCurrency(totalBase) }}</p>
                  </div>
                  <!-- <div>
                    <input type="text" class="inline-block" placeholder="Código de descuento">
                  </div> -->

                  <div v-if=" getUserHasServices "> 
                    <p v-if=" !servicesIdSelected " class="aviso">{{ $t('Tienes que elegir un servicio') }}!</p>
                    <select v-model="servicesIdSelected" required>
                      <option value="0" disabled>{{ $t('Elige tu servicio') }}</option>
                      <option v-for="item in getServices" :key=" item.srv_id " :value=" item.srv_id ">{{ item.srv_name }}</option>
                    </select>
                  </div>
                  
                  <div v-else>
                    <p>{{ $t('Facilítenos una dirección de correo electrónico para enviarle la confirmación del') + ' ' + sessionType }}.</p>
                    <input 
                      v-model=" confirmationEmail " 
                      :class=" { 'input-invalid': invalidEmail } "
                      placeholder="Email"
                      type="email"
                      autocomplete="on"
                    >
                  </div>
                  <p v-if=" cartCount < 1 && isCart " class="aviso">{{ $t('El carrito está vacío! Tiene que haber como mínimo un producto!') }}</p>
                  <p v-if=" offerCount < 1 && !isCart " class="aviso">{{ $t('La oferta está vacía! Tiene que haber como mínimo un producto!') }}</p>
                  <div class="cart_subtotal mt-4">
                    <p class="cart_amount checkout_btn"><a v-if="isCart" @click.prevent=" clearShoppingCart " href="#" class="color-red">{{ $t('Vaciar Carrito') }}</a></p>
                    <p class="checkout_btn">
                      <!-- <button @click.prevent=" punchOut " :disabled=" !checkoutValid ">
                        {{ getSessionType == 'procure' ? 'Punch Out' : 'Check Out' }}                        
                      </button> 
                      @click.prevent=" purchase.dialog = true " 
                      -->
                      <button     
                        @click="getComplementos"                    
                        :disabled=" !checkoutValid "
                        data-toggle="modal" data-target="#purchaseDialog"
                        class="btn-green"
                      >
                        {{ getSessionType == 'procure' ? 'Punch Out' :  $t('Finalizar compra') }}
                      </button>                       
                    </p>                      
                  </div>                    
                </div>
              </div>
              <p class="text-center mt-3">{{ $t('Todos los precios indicados no incluyen IVA') }}.</p>
            </div>            
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <products-related>
            </products-related>
          </div>
        </div>
      </div>     
    </div>
    <form ref="form" :action=" getPunchOutUrl " method="post" enctype="application/x-www-form-urlencoded">
      <input type="hidden" v-model="punchOutXML" name="cXML-urlencoded">
    </form>
  </div>
</template>

<i18n>
  {
    "es": {
      "Guardar carrito en lista de favoritos": "Guardar carrito en lista de favoritos",
      "Elige tu servicio": "Elige tu servicio",
      "Crear nueva lista de favoritos": "Crear nueva lista de favoritos",
      "Nombre": "Nombre",
      "Elige tu lista de favoritos": "Elige tu lista de favoritos",
      "Guardar en lista de favoritos": "Guardar en lista de favoritos",
      "Carrito": "Carrito",
      "¿Tienes dudas con el pedido?": "¿Tienes dudas con el pedido?",
      "Pedidos y logística": "Pedidos y logística",
      "Guardar carrito en una lista de favoritos": "Guardar carrito en una lista de favoritos",
      "Producto": "Producto",
      "Unidades por bolsa": "Unidades por bolsa",
      "Completar bolsa": "Completar bolsa",
      "Precio por unidad": "Precio por unidad",
      "Disponibilidad": "Disponi bilidad",
      "Unidades": "Unidades",
      "Total": "Total",
      "Imagen": "Imagen",
      "consultar": "consultar",
      "El carrito está vacío": "El carrito está vacío",
      "Observaciones sobre el pedido": "Observaciones sobre el pedido",
      "Gastos de envío": "Gastos de envío",
      "Portes pagados para pedidos superiores a 400 € que no incluyan tubería": "Portes pagados para pedidos superiores a 400 € que no incluyan tubería",
      "Portes pagados para pedidos superiores a 1500 € que incluyan tubería": "Portes pagados para pedidos superiores a 1500 € que incluyan tubería",
      "Resto de portes se cargan en pedido con IVA 21%": "Resto de portes se cargan en pedido con IVA 21%",
      "Totales": "Totales",
      "Total Base": "Total Base",
      "Tienes que elegir un servicio": "Tienes que elegir un servicio",
      "Vaciar Carrito": "Vaciar Carrito",
      "Todos los precios indicados no incluyen IVA": "Todos los precios indicados no incluyen IVA",
      "Tiene que añadir como mínimo una unidad al carrito!": "Tiene que añadir como mínimo una unidad al carrito!",
      "Borrado": "Borrado",
      "¿Estás seguro de borrar el elemento del carrito?": "¿Estás seguro de borrar el elemento del carrito?",
      "Si, bórralo!": "Si, bórralo!",
      "Cancelar": "Cancelar",
      "Vaciar Carrito": "Vaciar Carrito",
      "¿Estás seguro de vaciar el carrito?": "¿Estás seguro de vaciar el carrito?",
      "Si, vacíalo!": "Si, vacíalo!",
      "El carrito está vacío! Tiene que haber como mínimo un producto!": "El carrito está vacío! Tiene que haber como mínimo un producto!",
      "Check Out": "Check Out",
      "¿Estás seguro de realizar el pedido?": "¿Estás seguro de realizar el pedido?",
      "Si, realizar el pedido!": "Si, realizar el pedido!",
      "Checkout": "Checkout",
      "Su pedido se ha realizado con éxito!": "Su pedido se ha realizado con éxito!",
      "Cerrar": "Cerrar",
      "Error en el formato XML": "Error en el formato XML",
      "Error": "Error",
      "Punch Out": "Punch Out",
      "¿Estás seguro de realizar el Punch Out?": "¿Estás seguro de realizar el Punch Out?",
      "Si, Punch Out!": "Si, Punch Out!",
      "Ok": "Ok",
      "rellenar bolsa": "Para agilizar su pedido compre bolsas completas añadiendo una unidad | Para agilizar su pedido compre bolsas completas añadiendo {count} unidades",
      "Facilítenos una dirección de correo electrónico para enviarle la confirmación del": "Facilítenos una dirección de correo electrónico para enviarle la confirmación del",
      "¿Estás seguro de realizar el": "¿Estás seguro de realizar el",
      "Lo sentimos mucho, algo ha salido mal y no hemos podido procesar su": "Lo sentimos mucho, algo ha salido mal y no hemos podido procesar su",
      "Por favor, contacte con nosotros.": "Por favor, contacte con nosotros.",
      "El": "El",
      "se ha realizado con éxito!": "se ha realizado con éxito!",
      "Descargar PDF": "Descargar PDF",
      "Si, realizar": "Si, realizar",
      "Resumen del": "Resumen del",
      "Elige tu tipo de compra:": "Elige tu tipo de compra:",
      "Número de oferta": "Número de oferta",
      "Introduce tú número de oferta (OFXXXXXXXX) y presiona intro:": "Introduce tú número de oferta (OFXXXXXXXX) y presiona intro:",
      "Faltan": "Faltan", 
      "dígitos para completar el número de oferta": "dígitos para completar el número de oferta",
      "Buscando oferta...": "Buscando oferta...",
      "Oferta": "Oferta",
      "Oferta ": "Oferta ",
      "La oferta está vacía": "La oferta está vacía",
      "La oferta está vacía! Tiene que haber como mínimo un producto!": "La oferta está vacía! Tiene que haber como mínimo un producto!",
      "Número de oferta válido!": "Número de oferta válido!",
      "Número de oferta no válido!": "Número de oferta no válido!",
      "Finalizar compra": "Finalizar compra",
      "También podrías necesitar": "También podrías necesitar",
      "Volver al carrito": "Volver al carrito",
      "¿Estás seguro de finalizar la compra?": "¿Estás seguro de finalizar la compra?"
    },
    "en": {
      "Guardar carrito en lista de favoritos": "Save cart to favorites list",
      "Elige tu servicio": "Choose your service",
      "Crear nueva lista de favoritos": "Create new favorites list",
      "Nombre": "Name",
      "Elige tu lista de favoritos": "Choose your favorites list",
      "Guardar en lista de favoritos": "Save to favorites list",
      "Carrito": "Cart",
      "¿Tienes dudas con el pedido?": "Do you have questions about the order?",
      "Pedidos y logística": "Orders and logistics",
      "Guardar carrito en una lista de favoritos": "Save cart to favorites list",
      "Producto": "Product",
      "Unidades por bolsa": "Units by bag",
      "Completar bolsa": "Fill bag",
      "Precio por unidad": "Prize by unit",
      "Disponibilidad": "Availa bility",
      "Unidades": "Units",
      "Total": "Total",
      "Imagen": "Image",
      "consultar": "ask",
      "El carrito está vacío": "The shopping cart is empty",
      "Observaciones sobre el pedido": "Comments about the order",
      "Gastos de envío": "Shipping costs",
      "Portes pagados para pedidos superiores a 400 € que no incluyan tubería": "Free shipping costs for orders over € 400 that do not include pipes",
      "Portes pagados para pedidos superiores a 1500 € que incluyan tubería": "Free shipping costs for orders over € 1500 that include pipe",
      "Resto de portes se cargan en pedido con IVA 21%": "Rest of shipping costs are charged on order with VAT 21%",
      "Totales": "Totals",
      "Total Base": "Total Base",
      "Tienes que elegir un servicio": "You have to choose a service",
      "Vaciar Carrito": "Empty Cart",
      "Todos los precios indicados no incluyen IVA": "All prices indicated do not include VAT",
      "Tiene que añadir como mínimo una unidad al carrito!": "You have to add at least one unit to the cart!",
      "Borrado": "Delete",
      "¿Estás seguro de borrar el elemento del carrito?": "Are you sure to delete the item from the cart?",
      "Si, bórralo!": "Yes, delete it!",
      "Cancelar": "Cancel",
      "¿Estás seguro de vaciar el carrito?": "Are you sure to empty the cart?",
      "Si, vacíalo!": "Yes, empty it!",
      "El carrito está vacío! Tiene que haber como mínimo un producto!": "The cart is empty! There must be at least one item!",
      "Check Out": "Check Out",
      "¿Estás seguro de realizar el pedido?": "Are you sure to place the order?",
      "Si, realizar el pedido!": "Yes, place the order!",
      "Checkout": "Checkout",
      "Su pedido se ha realizado con éxito!": "Your order has been successful!",
      "Cerrar": "Close",
      "Error en el formato XML": "XML format error",
      "Error": "Error",
      "Punch Out": "Punch Out",
      "¿Estás seguro de realizar el Punch Out?": "Are you sure to do the Punch Out?",
      "Si, Punch Out!": "Yes, Punch Out!",
      "Ok": "Ok",
      "rellenar bolsa": "To speed up your order, buy complete bags by adding one unit | To speed up your order, buy complete bags by adding {count} units",
      "Facilítenos una dirección de correo electrónico para enviarle la confirmación del": "Provide us with an email address to send you the confirmation",
      "¿Estás seguro de realizar el": "Are you sure to",
      "Lo sentimos mucho, algo ha salido mal y no hemos podido procesar su": "We are very sorry, something has gone wrong and we have not been able to process your",
      "Por favor, contacte con nosotros.": "Please contact us.",
      "El": "The",
      "se ha realizado con éxito!": "has been done successfully!",
      "Descargar PDF": "Download PDF",
      "Si, realizar": "Yes, perform",
      "Resumen del": "Summary of the",
      "Elige tu tipo de compra:": "Choose your type of purchase:",
      "Número de oferta": "Offer number",
      "Introduce tú número de oferta (OFXXXXXXXX) y presiona intro:": "Enter your offer number (OFXXXXXXXX) and press enter:",
      "Faltan": " ",
      "dígitos para completar el número de oferta": "digits are missing to complete the offer number",
      "Buscando oferta...": "Searching offer...",
      "Oferta": "Offer",
      "Oferta ": "Offer ",
      "La oferta está vacía": "The offer is empty",
      "La oferta está vacía! Tiene que haber como mínimo un producto!": "Emprty offer! There must be at least one product",
      "Número de oferta válido!": "Valid offer number!",
      "Número de oferta no válido!": "Invalid offer number!",
      "Finalizar compra": "Complete purchase",
      "También podrías necesitar": "You may also need",
      "Volver al carrito": "Return to cart",
      "¿Estás seguro de finalizar la compra?": "Are you sure to complete the purchase?"
    }
  }
</i18n>

<script>
  import { mixin as focusMixin }  from 'vue-focus'

  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { mixinGlobal } from './../mixins/mixinGlobal'

  import ProductAdd from './helpers/ProductAdd'
  import ProductsRelated from './helpers/ProductsRelated'

  import Spinner from './helpers/Spinner.vue';

  export default {
    mixins: [ mixinGlobal, focusMixin ],
    components:{ ProductAdd, ProductsRelated, Spinner },
    data: () => {
      return {
        loading: false,
        cart: [],   // elements in the cart 
                    // this.offer.data: elements in the offer
                    // computed items: elements shown in the table
        punchOutXML: '',
        focused: null,
        servicesIdSelected: 0,
				serviceSelectedFavlists: [],
        observaciones: null,
        favlistModalVisbility: false,
        favlistModalLoading: false,
        favlistNameNew: '',
        favlistIdSelected: 0,
        shoppingcartEmptyWarning: false,
        mdl: null,
        mdl2: null,
        confirmationEmail: '',
        purchase: {
          dialog: false,
          state: 0,
          // 0 notice (¿realizar compra?)
          // 1 notice (pedido realizado con éxito)
          // 2 error
          xmlParseError: null,
          xmlResponse: null
        },
        offer: {
          value: '',
          validId: '', // last loaded offer ID
          data: [],    // elements in the offer shown in the shopping table if it's the case
          message: '',
          error: false,
          loading: false,
        },
        cartType: 'cart', // cart offer
        complements: {
          data: []
        }
      }

    },
    mounted () {
      //this.loadData();
      this.$store.dispatch('loadShoppingCart');

      this.servicesIdSelected = this.getSelectedService
      this.favlistIdSelected = this.getSelectedFavlist
      this.confirmationEmail = this.getUserEmail  //'john.doe@pohlbros.com'

      /* if( this.servicesIdSelected > 0 ){
				this.loadFavlists()
			} */

      // cart to favlist dialog
      this.mdl = $('#cartToFavlist')
			this.mdl.on('hide.bs.modal', () => {
				this.favlistModalVisbility = false
				//console.log(this.favlistModalVisbility)
			})
			this.mdl.on('shown.bs.modal', () => {
				this.favlistModalVisbility = true
				//console.log(this.favlistModalVisbility)
			})

      // Purchase verify dialog
      this.mdl2 = $('#purchaseDialog')
			this.mdl2.on('hide.bs.modal', () => {
				this.purchase.dialog = false
			})
			this.mdl2.on('shown.bs.modal', () => {
				this.purchase.dialog = true
			})
    },
    computed: {
      ...mapGetters(['getLocale', 'getBaseUrl', 'getApiUrl', 'getImgUrl', 'getShoppingCart', 'getShoppingCartLoading', 'getPunchOutUrl', 'getSessionType', 'getSelectedService', 'getSelectedFavlist', 'getFavlistsVisibility', 'getUserHasServices', 'getUserEmail', 'getServices', 'getRouteParams']),
      // elements showing in the shopping table
      items: {
        get: function(){
          if(this.cartType == 'cart'){
            return this.cart
          }else{
            return this.offer.data
          }
        },
        set: function(newValue){
          if(this.cartType == 'cart'){
            this.cart = newValue
          }else{
            this.offer.data = newValue
          }
        }
      },
      totalBase: function () {
        if( this.cartType == 'cart' ){
          return this.getShoppingCart.reduce( (total, item) => total + (item.ref_price * item.ref_quantity), 0); 
        }else{
          return this.offer.data.reduce( (total, item) => total + (item.ref_price * item.ref_quantity), 0); 
        }
      },
      totalIVA: function () {
        return (this.totalBase * 0.21); 
      },
      totalTotal: function () {
        return (this.totalBase + this.totalIVA);
      },
      cartCount: function(){
        //return this.getShoppingCart.length
        return this.getShoppingCart.filter( (item) => { return item.ref_number != "PORTES1" } ).length
      },
      offerCount: function(){
        return this.offer.data.filter( (item) => { return item.ref_number != "PORTES1" } ).length
      },
      serviceSelectedFavlistsSorted: function(){
				//console.log( this.serviceSelectedFavlists.length > 0 )
				if( this.serviceSelectedFavlists.length > 0 ){
					return this.serviceSelectedFavlists.sort((a, b) => a.fvl_name.localeCompare(b.fvl_name))
				}else{
					return '' 
				}
				return this.serviceSelectedFavlists
			},
			favlistNameNewValid: function () {
				if( this.favlistNameNew.length < 3  ){
					return false
				}else{
					//console.log(this.serviceSelectedFavlists)
					if( this.serviceSelectedFavlists.length > 0 ){
						let found = this.serviceSelectedFavlists.find(element => element.fvl_name.toLowerCase().trim() == this.favlistNameNew.toLowerCase().trim() )
						if ( found === undefined ){
							return true
						}else{
							return false
						}
					}else{
            return true
          }
				}
      },
      invalidEmail(){
        if( !this.isEmailValid( this.confirmationEmail ) ){
          return true
        }else{
          return false
        }
      },
      checkoutValid: function () {
        if( this.isCart ){
          if( this.cartCount > 0 ){
            this.shoppingcartEmptyWarning = false
            if( this.getUserHasServices && this.servicesIdSelected > 0  ){
              return true
            }else if( this.isEmailValid( this.confirmationEmail ) ){
              return true
            }else{
              return false
            }
          }else{
            this.shoppingcartEmptyWarning = true
          }
        }else{
          if( this.offerCount > 0 ){
            this.shoppingcartEmptyWarning = false
            if( this.getUserHasServices && this.servicesIdSelected > 0 ){
              return true
            }else if( this.isEmailValid( this.confirmationEmail ) ){
              return true
            }else{
              return false
            }
          }else{
            this.shoppingcartEmptyWarning = true
          }
        }
      },
      sessionType: function () {
        return this.getSessionType == 'checkout' ? 'Check Out' : 'Punch Out'
      },
      offerCharLack: function(){
        return 10 - this.offer.value.length
      },
      isCart: function(){
        return this.cartType == 'cart' ? true : false
      },
      cartTitle: function(){
        if( this.isCart ){
          return this.$t('Carrito')
        }else{
          let id = this.offerCount > 0 ? this.offer.validId : ''
          return this.$t('Oferta ') + id 
        }
      },
    },
    methods: { 
      ...mapMutations(['mutateShoppingCartLoading', 'mutateGlobalMessage']),
      ...mapActions(['addItemShoppingCart', 'deleteItemShoppingCart', 'loadShoppingCart']),
      editItem(item, index){
        this.focused = index;
        this.$set(item, 'editing',  true);
        this.$set(item, 'updateValue',  item.ref_quantity);
				//item.editing = true;
				//item.updateValue = item.ref_quantity;
			},
			updateItem(item){
				if( item.updateValue < 1 ){
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('Tiene que añadir como mínimo una unidad al carrito!') } )
				}else{
					this.$store.dispatch('updateItemShoppingCart', item);

					// !!!!! 
          this.$set(item, 'editing',  false);
				}
			},
			deleteItem(item){
				this.$swal.fire({
					title: this.$t('Borrado'),
					html: this.$t('¿Estás seguro de borrar el elemento del carrito?') + '<br><i><b>' + item.ref_description + '</b></i>',
					icon: 'warning',
					showCancelButton: true,
          confirmButtonText: this.$t('Si, bórralo!'),
          cancelButtonText: this.$t('Cancelar'),
					showClass: {
            popup: 'animated', // zoomIn
          },
          customClass: {
            confirmButton: 'btn c-bg-grey-blue text-white swal-btn',
            cancelButton: 'btn c-bg-blue-darker text-white swal-btn',
            title: 'swal-title',
            content: 'swal-content'
          }
				}).then((result) => {
					if( result.value ) {
						this.$store.dispatch('deleteItemShoppingCart', item);
					}
				})
      },
      clearShoppingCart(){
        this.$swal.fire({
					title: this.$t('Vaciar Carrito'),
					html: this.$t("¿Estás seguro de vaciar el carrito?"),
					icon: 'warning',
					showCancelButton: true,
          confirmButtonText: this.$t('Si, vacíalo!'),
          cancelButtonText: this.$t('Cancelar'),
					showClass: {
            popup: 'animated', // zoomIn
          },
          customClass: {
            confirmButton: 'btn c-bg-grey-blue text-white swal-btn',
            cancelButton: 'btn c-bg-blue-darker text-white swal-btn',
            title: 'swal-title',
            content: 'swal-content'
          }
				}).then((result) => {
					if( result.value ) {
						this.$store.dispatch('deleteItemShoppingCart', {});
					}
				})
      },
      parseXML(xmlStr){
        this.purchase.xmlParseError = null
        this.purchase.xmlResponse = null 

        const parser = new DOMParser();
        const doc = parser.parseFromString(xmlStr, "application/xml");
        // print the name of the root element or error message
        const errorNode = doc.querySelector("div");
        if (errorNode) {
          /* console.log(errorNode)
          console.log(doc.documentElement.nodeName)
          console.log(doc) */

          this.purchase.xmlParseError = errorNode.innerHTML
          this.purchase.xmlResponse = xmlStr

          return false
        } else {
          console.log('Valid XML')
          return true
        }
      },
      punchOut(){
        let offerParams = ''
        if( this.cartType == 'offer' ){
          offerParams = '&OFERTA=' + this.offer.value
        }else{
          offerParams = ''
        }

        if( (this.cartCount < 1 && this.isCart) || (this.offerCount < 1 && !this.isCart) ){
          this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('El carrito está vacío! Tiene que haber como mínimo un elemento!') } )
        
        // Checkout Aqualia
        }else if( this.getSessionType == 'checkout'){
         
          this.startLoading();

          if( !this.getUserHasServices ){
            this.observaciones = this.confirmationEmail + ' ' + this.observaciones
          }

          this.$axios.get(this.getApiUrl + 'punchout.php?srv_id=' + this.servicesIdSelected + offerParams + '&observaciones=' + encodeURIComponent(this.observaciones))
          .then( (respuesta) =>{   

            if( this.parseXML(respuesta.data) ){
              // 1 notice (pedido realizado con éxito)
              this.purchase.state = 1
              this.stopLoading();            
            }else{              
              //this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: this.$t('Error en el formato XML') } )

              // 2 error 
              this.purchase.state = 2
              this.stopLoading();
            }                
          })  
          .catch( (error) =>{ 
            let  message = '';
            if (error.response.hasOwnProperty('data')){
              if (error.response.data.hasOwnProperty('message')) {
                message = error.response.data.message;
              }else{
                message = error
              }
            }else{
              message = error
              this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message:   message } )
              this.stopLoading();
            }
          })              

        // Procure Acciona
        }else{
          // GET cXML for Punch Out
          this.startLoading();
          //this.punchOutXML = 'HOLA';

          if( !this.getUserHasServices ){
            this.observaciones = this.confirmationEmail + ' ' + this.observaciones
          }

          this.$axios.get(this.getApiUrl + 'punchout.php?&observaciones=' + this.observaciones + offerParams )
          .then( (respuesta) =>{ 
            if( this.parseXML(respuesta.data) ){
              // 1 notice (pedido realizado con éxito)
              this.purchase.state = 1
              this.punchOutXML = respuesta.data;
              this.$nextTick(() => {
                this.$refs.form.submit();
              })
              this.stopLoading();  

            }else{
              //this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: this.$t('Error en el formato XML') } )

              // 2 error
              this.purchase.state = 2
              this.stopLoading();
            }                
          })  
          .catch( (error) =>{ 
            let  message = '';
            if (error.response.hasOwnProperty('data')){
              if (error.response.data.hasOwnProperty('message')) {
                message = error.response.data.message;
              }else{
                message = error
              }
            }else{
              message = error
              this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: message } )
              this.stopLoading();
            }
          })              

        }
      },
      setAlertText(quantity, unitspp){
        let add = unitspp - (quantity % unitspp)
        //return 'Para agilizar su pedido compre bolsas completas añadiendo ' + add + ' unidad' + ( add > 1 ? 'es' : '' ) +' más'
        return this.$tc('rellenar bolsa', add, { count: add })
      },
      onAlertSubmit(item){
        item.updateValue = item.ref_quantity + (item.ref_unitspp - (item.ref_quantity % item.ref_unitspp))    
        this.$store.dispatch('updateItemShoppingCart', item);
      },
      loadFavlists(){
				this.favlistModalLoading = true
				this.$axios.get(this.getApiUrl + 'favoritos.php?srv_id=' + this.getSelectedService)
        .then( (respuesta) =>{ 
          this.serviceSelectedFavlists = respuesta.data.data
					this.favlistModalLoading = false
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
        }) 
			},
			addFavlist(){
				this.favlistModalLoading = true
				this.$axios.post(this.getApiUrl + 'favoritos.php', { fvl_name: this.favlistNameNew.trim(), fvl_srvid: this.getSelectedService })
        .then( (respuesta) =>{ 
					let newList = respuesta.data.data[0]
          this.favlistIdSelected = newList.fvl_id
          
					this.loadFavlists()
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: this.$t('Ok'), message: respuesta.data.message } )
					this.favlistNameNew = ''
					this.favlistModalLoading = false
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
				}) 
      },
      cartToFavlist(){
        this.favlistModalLoading = true
				this.$axios.post(this.getApiUrl + 'favoritos.php?fvl_id=' + this.getSelectedFavlist + '&srv_id=' + this.getSelectedService )
        .then( (respuesta) =>{ 
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: this.$t('Ok'), message: respuesta.data.message } )
          this.favlistModalLoading = false
          this.mdl.modal('hide')
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
				})
      },
      navToFavlists(){
				this.mdl.modal('hide')
				this.$router.push({ name: 'user-favlists', params: { language: this.getLocale } })
			},
      offerLoad(){
        if( this.offer.value.length != 10 ){
          return
        }
        this.offer.data = []
        this.offer.loading = true
        this.offer.message = ''
        this.offer.error = false

        this.$axios.get(this.getApiUrl + 'ofertas.php?OFERTA=' + this.offer.value)
        .then( (respuesta) =>{ 
          this.offer.data = respuesta.data.data
          this.offer.validId = this.offer.value
          this.offer.message = this.$t('Número de oferta válido!')
          this.offer.loading = false          
        })
        .catch( (error) =>{ 
          this.offer.loading = false   
          this.offer.message = this.$t('Número de oferta') + '<span class="text-uppercase mx-1">' + this.offer.value + '</span>' + this.$t('no válido!')
          this.offer.error = true
        })
      },
      offerReset(){
        this.offer.value = ''
        this.offer.data = []
        this.offer.loading = false
        this.offer.message = ''
        this.offer.error = false
      },
      setCartType(type){
        this.cartType = type
      },
      getComplementos(){
        this.complements.data = []
        this.$axios.get(this.getApiUrl + 'complementos.php')
        .then( (respuesta) =>{ 
          this.complements.data = respuesta.data.data       
        })
        .catch( (error) =>{
          console.log('Error complementos')
        })
      },
      goToComplement(item){
        this.mdl2.modal('hide')
        this.$nextTick( ()=>{
          this.$router.push({ name: 'type', params: { language: this.getLocale, lin: this.setUrlParams(item.lin_id,item.lin_name), ctg: this.setUrlParams(item.ctg_id,item.ctg_name), sct: this.setUrlParams(item.sct_id,item.sct_name), typ: this.setUrlParams(item.typ_id,item.typ_name)  } })
        })        
      }
    },
    watch:{
      getShoppingCart: {
        handler: function (val) {
          this.cart = val.slice()
        },
        deep: true
      },
      servicesIdSelected (newValue, oldValue){
      	if( newValue != oldValue ){
          this.$store.commit('mutateSelectedService', newValue)
          if( oldValue != 0 ){
            this.$store.commit('mutateSelectedFavlist', 0)
        		this.favlistIdSelected = 0
          }
					this.loadFavlists()
				}
			},
			favlistIdSelected (newValue, oldValue){
      	if( newValue != oldValue && !(typeof newValue === 'undefined' ) ){
					this.$store.commit('mutateSelectedFavlist', newValue)
				}
      },
      getUserEmail (newValue, oldValue){
        if( newValue != oldValue ){
          this.confirmationEmail = newValue
        }
      },
      purchase: {
        handler: function (value) {
          if( value.dialog == false && value.state == 1 ){
            if( this.cartType == 'cart' ){
              this.$store.dispatch('deleteItemShoppingCart', {});
            }else if( this.cartType == 'offer' ){
              this.offerReset()
            }
            value.state = 0
          }else if( value.dialog == false && value.state == 2 ){
            value.state = 0
          }
        },
        deep: true
      },
      /* cartType (newValue, oldValue){
        if( newValue == 'cart' ){
          this.items = this.cart
        }else{
          this.items = this.offer.data
        }
      } */
		}
  }
</script>

<style type="text/css">
  .product_thumb{ max-width: 50px !important; }
  .product_total{ padding: 10px 10px 10px 0; }
  .color-grey{ color: #777777 !important; }
  .color-light-grey{ color: #AAAAAA !important; }
  .color-red{ background-color: #FF5480 !important; }
  .contact_phone .question{ font-size: 16px;  }
  .unitspp{ font-size: 10px !important; font-weight: 500 !important; text-transform: uppercase; line-height: 12px; }
  .mouseHover{ cursor: pointer; }
  .c-mouseHover{ cursor: pointer; background-color: transparent; }
  .stock{ font-size: 16px; }
  .green{ color: #00CC00; }
  .yellow{ color: #FF9900; }

  .btn-fill-bolsa{
    position: relative;
    width: 46px;
    height: 46px;
    background-color: #EEE;
    margin: 0 auto;
  }
  .btn-fill-bolsa:hover{ 
    cursor: pointer; 
    background-color: #DDD; 
    color: #000; 
  }
  .btn-fill-bolsa:hover .count{
    background: #444;
    color: #FFF;
  } 
  .btn-fill-bolsa .cart{
    line-height: 46px;
    font-size: 30px;
  }
  .btn-fill-bolsa .count{
    min-width: 22px !important;
    min-height: 22px !important;
    line-height: 22px !important;
    font-weight: 300;
    position: absolute;
    top: 3px;
    right: 3px;
    background: #888;
    border-radius: 100%;
    font-size: 11px;
    color: #FFF;
  }
  .checkout_btn button{
    font-size: 14px;
    font-weight: 500;
    background-color: #2971f5;
  }
  .checkout_btnbutton:disabled,
  .checkout_btn button[disabled]{
    background-color: #cccccc;
    color: #FFF;
  }
  .aviso{
    margin-bottom: 0px !important;
    color: #FF0000 !important;
  }
  textarea{ 
    border: 1px #BBB solid; 
    color: #626262;
  }
  .input-invalid{
    border: 1px solid #FF0000 !important;
  }

  .modal-content button.close {
    left: auto !important;
    right: 10px !important;
  }
  
  .purchase-notice-icon{
    font-size: 80px;
    color: #BBB;
  }
  .red{ color: #A4305B; }

  .offer-input{
    text-transform: uppercase;
    border: 1px #BBB solid; 
    color: #626262 !important;
  }
  .offer-input::placeholder{
    color: #BBB !important;
  }
  .offer-loading{ margin-top: 12px; margin-left: 8px; }
  .offer-success{ color: #333; }
  .offer-error{ color: #FF0000  }
  .offer-loading-width{ width: 20px; }
  .offer-message-height{ height: 24px; }

  .cart-type-btn{ color: #FFF !important; background-color: #CCC; }
  .cart-type-btn:hover{ cursor: pointer; }
  .cart-type-active{ background-color: #2971f5 !important; }

  .btn-green{
    background-color: #08B11C !important;
  }
  .btn-green:disabled{
    background-color: #CCC !important;
  }

</style>